import { StatoNotaEnum } from "../enum/stato-nota-enum";
import { SettoreDTO } from "./settoreDTO";
import { UtenteDTO } from "./utenteDTO";
import { LineeFinanziamentoEnum } from "../enum/linee-finanziamento-enum";
import { TipoNotaLiquidazioneEnum } from "../enum/tipo-nota-liquidazione-enum";

export class FiltroRicercaNotaDTO {
  settore: SettoreDTO;
  ricercaSemplice: string;
  oggetto: string;
  stato: StatoNotaEnum | StatoNotaEnum[];
  statoDaEscludere: StatoNotaEnum;
  dataInserimentoDal: string;
  dataInserimentoAl: string;
  estensore: UtenteDTO;
  responsabile: UtenteDTO;
  numeroRepertorio: number;
  annoRepertorio: number;
  dataRepertoriazioneDal: string;
  dataRepertoriazioneAl: string;
  dataApprovazioneDal: string;
  dataApprovazioneAl: string;
  lineaFinanziamento: LineeFinanziamentoEnum;
  tipologiaNota: TipoNotaLiquidazioneEnum;
  beneficiario: string;
  codiceCor: string;
  presaInCarico: string;
  pageNumber: number;
  sort: string;
  direz: string;
}
